<template>
	<div class="gauge-container">
		<div class="gauge-image-container">
			<img class="gauge" src="/static/img/gauge.png" alt="gauge" width="78.9"
			/>
			<img ref="needle" class="needle" src="/static/img/stick.png" alt="needle"
				height="34.6" v-bind:style="needleDeg" />
		</div>
		<span class="ml-2 gauge-text">{{percent}} %</span>
	</div>
</template>

<script>

function mounted() {
	const deg = (270 + ((this.percent * 180) / 100));
	this.$refs.needle.style.transform = `rotate(${deg}deg)`;
}

function needleDeg() {
	const deg = (270 + ((this.percent * 180) / 100));
	return `transform: rotate(${deg}deg)`;
}

export default {
	name: 'gauge',
	computed: {
		needleDeg,
	},
	mounted,
	props: {
		heightNeedle: {
			type: [Number, String],
			default: 51.1,
		},
		widthGauge: {
			type: [Number, String],
			default: 78.9,
		},
		percent: {
			type: [Number, String],
			default: 0,
		},
	},
};
</script>

<style lang="scss" scoped>
.gauge-container {
	align-items: center;
	display: flex;
}

.gauge-image-container {
	position: relative;

	.gauge {
		vertical-align: bottom;
	}

}

.needle {
	position: absolute;
	left: 47.8%;
	transform: rotate(270deg);
	transform-origin: bottom center;
	transition: transform 0.3s ease-in;
	top: 10%;
}
</style>





// WEBPACK FOOTER //
// Gauge.vue?55969bf0